import "./notes.scss";
import { useState } from "react";
import { toast } from "react-toastify";
import { DeleteNote } from "../../services/noteBookService";
import IconButton from "../iconButton/iconButton";
import EditNooteBook from "../editNoteBook/editNoteBook";
import Confirm from "../confirm/confirm";
import AstrixIcon from "../../assets/images/astrix.svg";
import EditIcon from "../../assets/images/edit.svg";
import DeleteIcon from "../../assets/images/delete.svg";

export default function Notes({notes, onManipulation}) {
  const [editNoteId, setEditNoteId] = useState("");
  const [deleteNoteId, setDeleteNoteId] = useState("");
  const [deletLoading, setDeletLoading] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  
  const handleDeleteNote = async (noteId) => {
    setDeleteNoteId(noteId);
    if (showConfirmation) {
       try {
        setDeletLoading(deleteNoteId);
        await DeleteNote(deleteNoteId);
        setDeletLoading(null);
        setShowConfirmation(false);
        onManipulation();
      } catch (err) {
        setDeletLoading(null);
        toast.error(err.error, { toastId: "error" });
      }
    } else {
      setShowConfirmation(true);
    }
  }

  const afterEditNote = () => {
    setEditNoteId("");
    onManipulation();
  }

  return (
    <div className="notes">
      <Confirm
        message="آیا از حذف این یادداشت اطمینان دارید؟"
        display={showConfirmation}
        onConfirm={() => handleDeleteNote()}
        onCancel={() => setShowConfirmation(false)}
        loading={deletLoading}
      />   
      {notes.length > 0 && 
        notes.map( (note) => {
          return (
            <div className={`noteText ${editNoteId === note.ID ? "editing" : ""}`} key={note.ID}>
              <img src={AstrixIcon} alt="astrix" />
              {editNoteId === note.ID ? (
                <EditNooteBook text={note.note} noteId={note.ID} onCancel={() => setEditNoteId("")}  afterEditNote={afterEditNote}/>
              ) : (
                <>
                  <p>{note.note}</p>
                  <div className="noteIconWrapper">
                    <IconButton icon={EditIcon} tooltip="ویرایش" onClick={() => setEditNoteId(note.ID)} className="editRemoveIcon"/>
                    <IconButton icon={DeleteIcon} tooltip="حذف" onClick={() => handleDeleteNote(note.ID)} loading={deletLoading === note.ID} className="editRemoveIcon"/>
                  </div>
                </>
              )}
            </div>
          )
        })
      }
    </div>
  );
}
